var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Row',{attrs:{"wrap":false}},[_c('Col',{staticClass:"hi-card-title-div",attrs:{"flex":"auto"}},[_c('div',{staticClass:"hi-card-title-front"}),_c('label',{staticClass:"hi-card-title"},[_vm._v(_vm._s(_vm.labelText))])]),_c('Col',{attrs:{"flex":"none"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }